import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by Sinovo"
      links={[
        {
          key: 'AIMED',
          title: 'AIMED',
          href: 'https://aimed.yidudao.cn',
          blankTarget: true,
        },
        {
          key: 'github',
          title: <GithubOutlined />,
          href: '#',
          blankTarget: true,
        },
        {
          key: 'sinovo',
          title: '易督导',
          href: '#',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
